export default "__VITE_ASSET__BQ6RG2Wx__"